import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { ClientInfo } from "./ClientInfo";
import { ClientDetails } from "./ClientDetails";
import { ClientData, ClientMeetingSummary, clientService } from "../../services/clientService";

interface ClientCardProps {
  client: ClientData;
  clientType?: string;
}

export const ClientCard = React.memo(function ClientCard({ client, clientType }: ClientCardProps) {
  // Projects / pending actions are derived from this client's meetings. We load
  // them lazily so the card (name, status, meeting count, dates) shows instantly
  // and these fields fill in once the meetings request resolves.
  const [summary, setSummary] = useState<ClientMeetingSummary | null>(null);

  useEffect(() => {
    let active = true;
    clientService
      .getClientMeetingSummary(client.id, clientType)
      .then((s) => {
        if (active) setSummary(s);
      })
      .catch(() => {
        /* keep the default values already on `client` */
      });
    return () => {
      active = false;
    };
  }, [client.id, clientType]);

  return (
    <Box
      as="article"
      display="flex"
      bg="white"
      borderRadius="lg"
      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
      overflow="hidden"
      width="100%"
      height="100%"
      maxW="570px"
      border="1px solid #E2E8F0"
      position="relative"
      transition="all 0.3s ease"
      _hover={{
        transform: "scale(1.02)", 
        boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.15)",
        borderColor: "#805ad6",
      }}
    >
      <Box display="flex" width="100%" height="100%" position="relative">
        <ClientInfo
          name={client.name}
          status={client.status}
          email={client.email}
          phone={client.phone}
        />
        <Box
          position="absolute"
          left="254px"
          top="0"
          bottom="0"
          width="1px"
          bg="gray.100"
          zIndex="1"
        />
        <ClientDetails
          type={client.type}
          projectsShown={summary?.projectsShown ?? client.projectsShown}
          projectsList={summary?.projectsList ?? client.projectsList}
          pendingAction={summary?.pendingAction ?? client.pendingAction}
          lastMeeting={client.lastMeeting}
          totalMeetings={client.totalMeetings}
          isPendingActionHighlighted={summary?.isPendingActionHighlighted ?? client.isPendingActionHighlighted}
          clientId={client.id}
          name={client.name}
          email={client.email}
          lastMeetingDate={client.lastMeetingDate}
          meetingCount={client.meetingCount || 0}
          nextMeetingDate={client.nextMeetingDate}
        />
      </Box>
    </Box>
  );
}); 